(function () {
    'use strict';

    if (window.__productThumbsArrowsLoaded__) return;
    window.__productThumbsArrowsLoaded__ = true;

    enhanceAll();
    document.addEventListener('shopify:section:load', enhanceAll);
    document.addEventListener('shopify:section:reorder', enhanceAll);

    function enhanceAll() {
        document.querySelectorAll('product-thumbs').forEach(enhanceThumbs);
    }

    function enhanceThumbs(root) {
        if (root.dataset.arrowsAttached === 'true') return;

        const slider = root.querySelector('[data-thumbs-slider]');
        const prevBtn = root.querySelector('[data-thumbs-prev]');
        const nextBtn = root.querySelector('[data-thumbs-next]');

        if (!slider || !prevBtn || !nextBtn) return; 

        root.dataset.arrowsAttached = 'true';
        root.classList.add('thumbs-has-arrows');

        if (getComputedStyle(root).position === 'static') {
            root.style.position = 'relative';
        }

        let vertical = false;
        const detectAxis = () => {
            vertical =
                slider.scrollHeight > slider.clientHeight + 1 &&
                slider.scrollHeight - slider.clientHeight >
                slider.scrollWidth - slider.clientWidth;
            root.classList.toggle('thumbs-vertical', vertical);
            root.classList.toggle('thumbs-horizontal', !vertical);
        };

        const step = () => (vertical ? slider.clientHeight || 200 : slider.clientWidth || 200);

        prevBtn.addEventListener('click', () => { 
            vertical
                ? slider.scrollBy({ top: -step(), behavior: 'smooth' })
                : slider.scrollBy({ left: -step(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
            vertical
                ? slider.scrollBy({ top: step(), behavior: 'smooth' })
                : slider.scrollBy({ left: step(), behavior: 'smooth' });
        });

        const updateDisabled = () => {
            detectAxis();

            const count = slider.querySelectorAll('[data-thumb-item]').length;

            const overflow = vertical 
                ? slider.scrollHeight > slider.clientHeight + 1
                : slider.scrollWidth > slider.clientWidth + 1;

            const show = count > 1 && overflow;
            prevBtn.style.display = nextBtn.style.display = show ? '' : 'none';
            if (!show) return;

            if (vertical) {
                const atStart = slider.scrollTop <= 0;
                const atEnd =
                    slider.scrollTop + slider.clientHeight >= slider.scrollHeight - 1;
                prevBtn.disabled = atStart;
                nextBtn.disabled = atEnd;
            } else {
                const atStart = slider.scrollLeft <= 0;
                const atEnd =
                    slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
                prevBtn.disabled = atStart;
                nextBtn.disabled = atEnd;
            }
        };

        slider.addEventListener('scroll', updateDisabled, { passive: true });
        window.addEventListener('resize', updateDisabled);

        const mo = new MutationObserver(updateDisabled);
        mo.observe(slider, { childList: true, subtree: true });

        requestAnimationFrame(updateDisabled);
    }
})();
  